/* eslint-disable @typescript-eslint/no-explicit-any */
import { Widget } from '@typeform/embed-react';
import React from 'react';
import type { BoxProps } from 'rebass/styled-components';

import { withErrorBoundary } from '../../components';

export interface EmbeddedContentModuleProps extends BoxProps {
  id: string;
  ID: any;
  embedType: string;
  title: string;
  name: string;
}

const EmbeddedContentModule = React.forwardRef<HTMLDivElement, EmbeddedContentModuleProps>(({ ID, embedType }) => {
  if (embedType === 'Typeform') {
    // Extract the typeform ID from the URL, handling both simple URLs and URLs with hash fragments
    const urlString = typeof ID === 'string' ? ID : ID.ID;

    // Split URL to separate base URL and hash fragment
    const [urlWithoutHash, hashFragment] = urlString?.split('#') || [];

    // Extract the form ID (last part after the last slash)
    const typeformId = urlWithoutHash?.split('/').pop();

    // Extract tracking parameters from hash fragment
    let hiddenParams = {};
    if (hashFragment) {
      hiddenParams = Object.fromEntries(new URLSearchParams(hashFragment));
    }

    return (
      <Widget
        id={typeformId}
        style={{ width: '100%' }}
        className="my-form md:-mb-[35px]"
        autoResize={true}
        hidden={hiddenParams}
        noScrollbars={true}
        hideHeaders
        hideFooter
        inlineOnMobile={true}
      />
    );
  } else if (embedType === 'Issuu') {
    // Extract the Issuu ID from the URL, handling both simple URLs and URLs with hash fragments
    const urlString = typeof ID === 'string' ? ID : ID.ID;

    // Split URL to separate base URL and hash fragment
    const [urlWithoutHash] = urlString?.split('#') || [];

    // Extract the ID (last part after the last slash)
    const issuuId = urlWithoutHash?.split('/').pop();

    return (
      <div style={{ height: 0, paddingTop: 'max(60%,326px)', position: 'relative', width: '100%' }}>
        <iframe
          title="Issuu Document Viewer"
          allow="clipboard-write"
          sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
          allowFullScreen={true}
          style={{
            border: 'none',
            bottom: 0,
            height: '100%',
            left: 0,
            position: 'absolute',
            right: 0,
            top: 0,
            width: '100%',
          }}
          src={`https://e.issuu.com/embed.html?d=${issuuId}&u=arvesta.internal.communications`}
        />
      </div>
    );
  } else {
    console.log(embedType);
  }

  return null;
});
EmbeddedContentModule.displayName = 'EmbeddedContentModule';

export default withErrorBoundary(EmbeddedContentModule, { componentName: 'EmbeddedContentModule' });
